import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import CanvasStaticStepper, { readStaticStepper } from "./CanvasStaticStepper";

describe("readStaticStepper", () => {
  it("is off without a non-empty steps list", () => {
    expect(readStaticStepper({})).toBeUndefined();
    expect(readStaticStepper({ steps: [] })).toBeUndefined();
    expect(readStaticStepper({ steps: [{ nolabel: 1 }, 5] })).toBeUndefined();
  });

  it("reads string and object steps from the props or timeline_config", () => {
    expect(
      readStaticStepper({
        steps: ["Submitted", { label: "Review", description: "HR" }],
        current_step: "Review",
      }),
    ).toEqual({
      steps: [{ label: "Submitted" }, { label: "Review", description: "HR" }],
      currentStep: "Review",
    });
    expect(
      readStaticStepper({
        timeline_config: { steps: ["A"], current_step: "A" },
      }),
    ).toEqual({ steps: [{ label: "A" }], currentStep: "A" });
  });
});

describe("CanvasStaticStepper", () => {
  const steps = [
    { label: "Submitted" },
    { label: "In review", description: "With HR" },
    { label: "Approved" },
  ];
  const states = () =>
    screen
      .getAllByTestId("stepper-step")
      .map((node) => node.getAttribute("data-step-state"));

  it("marks steps before the current one done and after it upcoming", () => {
    render(
      <CanvasStaticStepper
        title="Request status"
        config={{ steps, currentStep: "In review" }}
      />,
    );
    expect(states()).toEqual(["done", "current", "upcoming"]);
    expect(screen.getByText("Request status")).toBeInTheDocument();
    expect(screen.getByText("With HR")).toBeInTheDocument();
    expect(screen.getByText("In review")).toHaveAttribute(
      "aria-current",
      "step",
    );
  });

  it("shows every step as upcoming when the current step is unknown", () => {
    render(<CanvasStaticStepper config={{ steps, currentStep: "Nope" }} />);
    expect(states()).toEqual(["upcoming", "upcoming", "upcoming"]);
  });

  it("marks the last step current without marking others done", () => {
    render(<CanvasStaticStepper config={{ steps, currentStep: "Approved" }} />);
    expect(states()).toEqual(["done", "done", "current"]);
  });
});
